<template>
 <div>
   <div class="exam-stats">
    <div class="stats-title">正式考试情况统计</div>
    <div class="stats-bars">
      <div class="bar-item">
        <div class="bar-label">通过率</div>
        <div class="bar-container">
          <div class="bar-fill"
               :style="{ width: passRate }"></div>
        </div>
        <div class="bar-value">{{ passRate }}</div>
      </div>
      <div class="bar-item">
        <div class="bar-label">正确率</div>
        <div class="bar-container">
          <div class="bar-fill"
               :style="{ width: correctRate }"></div>
        </div>
        <div class="bar-value">{{ correctRate }}</div>
      </div>
      <div class="bar-item">
        <div class="bar-label">得分率</div>
        <div class="bar-container">
          <div class="bar-fill"
               :style="{ width: scoreRate }"></div>
        </div>
        <div class="bar-value">{{ scoreRate }}</div>
      </div>
    </div>
  </div>
  <!-- 模拟考试 -->
    <div class="exam-stats">
    <div class="stats-title">模拟考试情况统计</div>
    <div class="stats-bars">
      <div class="bar-item">
        <div class="bar-label">通过率</div>
        <div class="bar-container">
          <div class="bar-fill"
               :style="{ width: mockPassRate }"></div>
        </div>
        <div class="bar-value">{{ mockPassRate }}</div>
      </div>
      <div class="bar-item">
        <div class="bar-label">正确率</div>
        <div class="bar-container">
          <div class="bar-fill"
               :style="{ width: mockCorrectRate }"></div>
        </div>
        <div class="bar-value">{{ mockCorrectRate }}</div>
      </div>
      <div class="bar-item">
        <div class="bar-label">得分率</div>
        <div class="bar-container">
          <div class="bar-fill"
               :style="{ width: mockScoreRate }"></div>
        </div>
        <div class="bar-value">{{ mockScoreRate }}</div>
      </div>
    </div>
  </div>
 </div>
</template>

<script>
import { examSituation } from "@/api/index.js";
export default {
  name: 'ExamStats',
  data() {
    return {
      passRate: '0%', // 通过率
      correctRate: '0%', // 正确率
      scoreRate: '0%', // 得分率
      mockPassRate: '0%', // 通过率
      mockCorrectRate: '0%', // 正确率
      mockScoreRate: '0%' // 得分率
    }
  },
  created () {
    this.getExamSituation();
    this.getMockExamSituation();
  },
  methods: {
    async getExamSituation() {
      const { code, data } = await examSituation({examMode:0})
      if (code === 200) {
        const passRate = Number(((Number(data.passRate) || 0)* 100).toFixed(2))
        const correctRate = Number(((Number(data.correctRate) || 0)* 100).toFixed(2))
        const scoreRate = Number(((Number(data.scoreRate) || 0)* 100).toFixed(2))
        this.passRate = `${passRate}%`
        this.correctRate = `${correctRate}%`
        this.scoreRate = `${scoreRate}%`
      }
    },
    async getMockExamSituation() {
      const { code, data } = await examSituation({examMode:1})
      if (code === 200) {
        const mockPassRate = Number(((Number(data.passRate) || 0)* 100).toFixed(2))
        const mockCorrectRate = Number(((Number(data.correctRate) || 0)* 100).toFixed(2))
        const mockScoreRate = Number(((Number(data.scoreRate) || 0)* 100).toFixed(2))
        this.mockPassRate = `${mockPassRate}%`
        this.mockCorrectRate = `${mockCorrectRate}%`
        this.mockScoreRate = `${mockScoreRate}%`
      }
    }
  },
}
</script>

<style lang="less" scoped>
.exam-stats {
  background: white;
  margin: 0 16px 20px;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .stats-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 20px;
  }

  .stats-bars {
    .bar-item {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      .bar-label {
        width: 60px;
        font-size: 14px;
        color: #333;
      }

      .bar-container {
        flex: 1;
        height: 8px;
        background: #e5e5e5;
        border-radius: 4px;
        margin: 0 12px;
        overflow: hidden;

        .bar-fill {
          height: 100%;
          background: #1989fa;
          border-radius: 4px;
          transition: width 0.3s ease;
        }
      }

      .bar-value {
        width: 40px;
        text-align: right;
        font-size: 14px;
        color: #666;
      }
    }
  }
}
</style>